<form name="formGroup" [formGroup]="formGroup" (ngSubmit)="onSave()">
    <div mat-dialog-content>
        <h2>Set Date Range</h2>

        <mat-form-field class="dialog-input-field mr-24">
            <mat-label>Start Date</mat-label>
            <input matInput
                   formControlName="startDate"
                   placeholder="Start Date"
                   type="datetime-local"
                   [required]="true"
                   (change)="changeStartDate()"
            >
        </mat-form-field>

        <mat-form-field class="dialog-input-field">
            <mat-label>End Date</mat-label>
            <input matInput
                   formControlName="endDate"
                   placeholder="End Date"
                   type="datetime-local"
                   [required]="true"
                   (change)="changeEndDate()"
            >
        </mat-form-field>
    </div>

    <mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
        <button mat-button
                type="button"
                (click)="onClose()"
                class="mr-8"
                tabindex="12"
        >
            Cancel
        </button>

        <button mat-raised-button
                color="primary"
                type="submit"
                [disabled]="formGroup?.invalid"
        >
            Set
        </button>
    </mat-dialog-actions>
</form>
